import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// Self-hosted variable fonts. Inter for UI, Source Serif 4 for scholarly
// content. Loading the variable axes once keeps the bundle small while
// covering every weight the design tokens reach for.
import "@fontsource-variable/inter";
import "@fontsource-variable/source-serif-4";

import { App } from "./App";
import "./styles/globals.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element not found");

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
